import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const ClinicLineChart = ({monthlyOverview}) => {
  const chartOptions = {
    chart: {
      type: "column",
      height: 350,
    },
    title: {
      text: "Clinic Statistics",
    },
    xAxis: {
      categories: monthlyOverview.map(m=>m.monthName),
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "Counts",
      },
    },
    tooltip: {
      shared: true,
      valueSuffix: "",
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        borderRadius: 4,
      },
    },
    series: [
      {
        name: "Total Revenue",
        data: monthlyOverview.map(m=>m.totalRevenue),
        color: "#2563eb",
      },
      {
        name: "Patients",
        data: monthlyOverview.map(m=>m.totalPatients),
        color: "#4ade80",
      },
    ],
    credits: {
      enabled: false, 
    },
    legend: {
      align: "center",
      verticalAlign: "bottom",
    },
  };

  return (
    <div className="rounded-lg border bg-white p-4 shadow-sm">
      <h2 className="text-xl font-semibold leading-tight mb-2 tracking-tight">
        Monthly Overview
      </h2>
      <p className="text-sm text-muted-foreground mb-4">
        Total revenue and patient visits
      </p>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
};

export default ClinicLineChart;
